import React, { useEffect, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CustomCodeInjector from './components/CustomCodeInjector';
import WhatsAppButton from './components/WhatsAppButton';

const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const AboutGurugramCampus = React.lazy(() => import('./pages/AboutGurugramCampus'));
const PrincipalMessage = React.lazy(() => import('./pages/PrincipalMessage'));
const Admission = React.lazy(() => import('./pages/Admission'));
const Fees = React.lazy(() => import('./pages/Fees'));
const Academics = React.lazy(() => import('./pages/Academics'));
const Facilities = React.lazy(() => import('./pages/Facilities'));
const GalleryPage = React.lazy(() => import('./pages/GalleryPage'));
const GalleryDetail = React.lazy(() => import('./pages/GalleryDetail'));
const Events = React.lazy(() => import('./pages/Events'));
const News = React.lazy(() => import('./pages/News'));
const Blog = React.lazy(() => import('./pages/Blog'));
const BlogDetail = React.lazy(() => import('./pages/BlogDetail'));
const Contact = React.lazy(() => import('./pages/Contact'));
const DynamicPage = React.lazy(() => import('./pages/DynamicPage'));
const CoreValues = React.lazy(() => import('./pages/CoreValues'));
const OurPhilosophy = React.lazy(() => import('./pages/OurPhilosophy'));
const Recognition = React.lazy(() => import('./pages/Recognition'));
const Accreditation = React.lazy(() => import('./pages/Accreditation'));
const AdmissionGuidelines = React.lazy(() => import('./pages/AdmissionGuidelines'));
const CbseBoard = React.lazy(() => import('./pages/CbseBoard'));
const CurriculumInfrastructure = React.lazy(() => import('./pages/CurriculumInfrastructure'));
const WhyUs = React.lazy(() => import('./pages/WhyUs'));
const StudentCorner = React.lazy(() => import('./pages/StudentCorner'));
const InfrastructurePage = React.lazy(() => import('./pages/InfrastructurePage'));
const StudentEngagementPage = React.lazy(() => import('./pages/StudentEngagementPage'));
const OtherFacilitiesPage = React.lazy(() => import('./pages/OtherFacilitiesPage'));
const OurProgrammesPage = React.lazy(() => import('./pages/OurProgrammesPage'));
const FoundationalProgrammePage = React.lazy(() => import('./pages/FoundationalProgrammePage'));
const ExposureCodingPage = React.lazy(() => import('./pages/ExposureCodingPage'));
const ExtraCurricularActivitiesPage = React.lazy(() => import('./pages/ExtraCurricularActivitiesPage'));
const JuniorSchoolProgrammePage = React.lazy(() => import('./pages/JuniorSchoolProgrammePage'));
const PreparatoryProgrammePage = React.lazy(() => import('./pages/PreparatoryProgrammePage'));
const MiddleSchoolProgrammePage = React.lazy(() => import('./pages/MiddleSchoolProgrammePage'));
const SeniorSchoolProgrammePage = React.lazy(() => import('./pages/SeniorSchoolProgrammePage'));
const OurSchools = React.lazy(() => import('./pages/OurSchools'));

const ScrollToTop = () => {
 const { pathname } = useLocation();
 useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
 return null;
};

function App() {
 return (
 <>
 <ScrollToTop />
 <Header />
 <CustomCodeInjector />
 <Suspense fallback={<div className="w-full h-[60vh] flex items-center justify-center"><div className="animate-pulse text-primary font-semibold text-lg">Loading...</div></div>}>
 <Routes>
 <Route path="/" element={<Home />} />
 <Route path="/about-standrews-group" element={<About />} />
 <Route path="/about" element={<About />} />
 <Route path="/about-gurugram-campus" element={<AboutGurugramCampus />} />
 <Route path="/principal-message" element={<PrincipalMessage />} />
 <Route path="/admission" element={<Admission />} />
 <Route path="/fees" element={<Fees />} />
 <Route path="/core-values" element={<CoreValues />} />
 <Route path="/our-philosophy" element={<OurPhilosophy />} />
 <Route path="/recognition" element={<Recognition />} />
 <Route path="/accreditation" element={<Accreditation />} />
 <Route path="/admission-guidelines" element={<AdmissionGuidelines />} />
 <Route path="/cbse-board" element={<CbseBoard />} />
 <Route path="/curriculum" element={<CurriculumInfrastructure />} />
 <Route path="/why-us" element={<WhyUs />} />
 <Route path="/student-corner" element={<StudentCorner />} />
 <Route path="/infrastructure" element={<InfrastructurePage />} />
 <Route path="/beyond-classroom" element={<StudentEngagementPage />} />
 <Route path="/other-facilities" element={<OtherFacilitiesPage />} />
 <Route path="/our-programmes" element={<OurProgrammesPage />} />
 <Route path="/foundational-programme" element={<FoundationalProgrammePage />} />
 <Route path="/exposure-to-programming-and-coding-languages" element={<ExposureCodingPage />} />
 <Route path="/extra-curricular-activities" element={<ExtraCurricularActivitiesPage />} />
 <Route path="/preparatory-programme" element={<PreparatoryProgrammePage />} />
 <Route path="/junior-school-programme" element={<JuniorSchoolProgrammePage />} />
 <Route path="/middle-school-programme" element={<MiddleSchoolProgrammePage />} />
 <Route path="/senior-school-programme" element={<SeniorSchoolProgrammePage />} />
 <Route path="/our-schools" element={<OurSchools />} />
 {/* WP slug aliases */}
 <Route path="/about-us" element={<About />} />
 <Route path="/contact-us" element={<Contact />} />
 <Route path="/principals-message" element={<PrincipalMessage />} />
 <Route path="/academics" element={<Academics />} />
 <Route path="/facilities" element={<Facilities />} />
 <Route path="/facilities/:slug" element={<Facilities />} />
 <Route path="/gallery" element={<GalleryPage />} />
 <Route path="/gallery/:slug" element={<GalleryDetail />} />
 <Route path="/events" element={<Events />} />
 <Route path="/news" element={<News />} />
 <Route path="/blog" element={<Blog />} />
 <Route path="/blog/:slug" element={<BlogDetail />} />
 <Route path="/contact" element={<Contact />} />
 <Route path="/:slug" element={<DynamicPage />} />
 </Routes>
 </Suspense>
 <WhatsAppButton />
        <Footer />
 </>
 );
}

export default App;


